import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-[var(--bg)] h-full" }
const _hoisted_2 = {
  key: 1,
  class: "fixed inset-0 bg-black/10 backdrop-blur-sm z-[90] flex items-center justify-center"
}
const _hoisted_3 = {
  key: 5,
  class: "fixed top-10 flex flex-col justify-center w-full px-2 pt-2 bg-[var(--bg)] z-20 sm:hidden"
}
const _hoisted_4 = { class: "flex flex-row items-center w-full mb-2" }
const _hoisted_5 = { class: "w-6 h-6 flex items-center justify-center" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "w-full fixed z-40" }
const _hoisted_8 = { class: "flex-1 flex flex-col" }
const _hoisted_9 = { class: "min-h-screen" }
const _hoisted_10 = {
  key: 0,
  class: "bg-[var(--bg)] group"
}
const _hoisted_11 = { class: "container mx-auto px-12 text-center sm:px-24" }
const _hoisted_12 = { class: "flex flex-col justify-between w-full py-16 mb-8 sm:flex-row sm:items-start" }
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex space-x-12 mr-0 opacity-30 group-hover:opacity-100 transition-all duration-500 ease-in-out sm:mr-20 sm:mx-0 sm:space-x-20" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_18 = { class: "text-left" }
const _hoisted_19 = { class: "space-y-2 text-xs text-[var(--text)] font-light pl-1" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "flex justify-between items-center border-t border-[var(--border)] pt-8 pb-20" }
const _hoisted_22 = { class: "text-xs text-[var(--text-secondary)] font-light" }
const _hoisted_23 = ["src"]

import {
  computed,
  watch,
  defineAsyncComponent,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const route = useRoute();

const Notifications = defineAsyncComponent(() => import('@/components/global/notifications.vue'));
const UploadStatusPanel = defineAsyncComponent(() => import('@/components/global/upload-status-panel.vue'));
const Sidebar = defineAsyncComponent(() => import('@/components/global/sidebar.vue'));
const Navbar = defineAsyncComponent(() => import('@/components/global/navbar.vue'));
const AudioRecorder = defineAsyncComponent(() => import('@/components/global/audio-recorder.vue'));
const PreviewModal = defineAsyncComponent(() => import('@/components/app/preview-modal.vue'));
const InfoModal = defineAsyncComponent(() => import('@/components/app/info-modal.vue'));
const ShareModal = defineAsyncComponent(() => import('@/components/app/share-modal.vue'));

const activeInfoDimensions = ref<{ width: number; height: number } | null>(null);
const activeInfoDuration = ref<number>(0);

let searchTimeout: number | undefined;

const fileInputBtn = ref<HTMLInputElement | null>(null);
const photoInputBtn = ref<HTMLInputElement | null>(null);
const inputKey = ref(0);

async function uploadFile(event: Event): Promise<void> {
  const input = event.target as HTMLInputElement;
  if (!input || !input.files || input.files.length === 0) return;

  const filesArray = Array.from(input.files);

  const formData = new FormData();
  filesArray.forEach((fileItem) => {
    console.log('fileItem->', fileItem);
    formData.append('file', fileItem);
  });

  let currentFolderId: number | null = null;
  if (route.name === 'folder-details' || route.path.includes('/app/folders/')) {
    currentFolderId = route.params.id ? Number(route.params.id) : null;
  }

  try {
    console.log('formData->', formData);
    await store.dispatch('files/upload', { formData, folderId: currentFolderId });
  } catch (error: unknown) {
    console.error(error);
  } finally {
    if (input) {
      input.value = '';
    }

    // eslint-disable-next-line no-plusplus
    inputKey.value++;
  }
}

const { VUE_APP_DG_USERS_APP } = process.env;

const year = ref(new Date().getUTCFullYear());
const usersLink = ref(`${VUE_APP_DG_USERS_APP}`);
const query = ref<string>('');

const isHome = computed(() => route.name === 'home');
const hideBar = computed(() => route.name === 'home' || route.name === 'login' || route.name === 'register');
const isAuth = computed(() => store.getters['auth/isAuth']);
const isLight = computed(() => store.state.theme?.theme === 'light');
const showSidebar = computed(() => isAuth.value && route.name !== 'home');
const showSidebarState = computed<boolean>(() => store.state.sidebar);
const showSidebarMovil = computed(() => showSidebarState.value);
const isRecording = computed(() => store.state.isRecording);

const activePreviewFile = computed(() => store.state.files.activePreviewFile);
const previewFilesList = computed(() => store.state.files.previewFilesList);
const activeInfoFile = computed(() => store.state.files.activeInfoFile);
const activeShareFile = computed(() => store.state.files.activeShareFile);

const currentYear = new Date().getFullYear();

const clickOutside = () => {
  if (showSidebar.value) store.commit('toggleSidebar');
};

const toggleTheme = () => {
  store.dispatch('theme/toggleTheme');
  const newTheme = store.state.theme.theme;

  document.documentElement.classList.toggle('light', newTheme === 'light');
};

const toggleSidebar = () => {
  store.commit('toggleSidebar');
};

async function handleSearch() {
  const payload = {
    page: 1,
    q: query.value,
  };

  await store.dispatch('files/filter', payload);
  router.replace({
    query: {
      ...payload,
    },
  });

  router.push({
    path: '/app/search',
    query: {
      ...payload,
    },
  });
}
async function handleInput() {
  if (searchTimeout) {
    clearTimeout(searchTimeout);
  }
  searchTimeout = setTimeout(() => {
    handleSearch();
  }, 500);
}

async function downloadFile(file: any) {
  await store.dispatch('files/downloadFile', file);
}

async function copyLink(file: any) {
  try {
    const url = await store.dispatch('files/getDownloadUrl', file);
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      store.commit('notifications/addNotification', {
        message: 'Link copied to clipboard',
        type: 'success',
      });
    }
  } catch (error) {
    console.error('Error:', error);
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSidebar.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black opacity-50 z-30 hidden",
          onClick: toggleSidebar,
          onKeydown: toggleSidebar
        }, null, 32))
      : _createCommentVNode("", true),
    _createVNode(_unref(Notifications)),
    _createVNode(_unref(UploadStatusPanel)),
    _createVNode(_unref(Navbar)),
    _createVNode(_unref(AudioRecorder)),
    (isRecording.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "bg-[var(--bg-modal-2)] backdrop-blur-sm px-6 py-2 rounded-full border border-[var(--border)] shadow-xl text-[var(--text)] text-sm font-medium animate-pulse" }, " Recording in progress... ", -1)
        ]))]))
      : _createCommentVNode("", true),
    (activePreviewFile.value)
      ? (_openBlock(), _createBlock(_unref(PreviewModal), {
          key: 2,
          modelValue: activePreviewFile.value,
          files: previewFilesList.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => _unref(store).commit('files/setActivePreviewFile', val)),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(store).commit('files/setActivePreviewFile', null))),
          onOpenInfo: _cache[2] || (_cache[2] = (file, dimensions, duration) => {
        _unref(store).commit('files/setActiveInfoFile', file);
        activeInfoDimensions.value = dimensions;
        activeInfoDuration.value = duration;
      }),
          onCopyLink: _cache[3] || (_cache[3] = ($event: any) => (_unref(store).commit('files/setActiveShareFile', $event))),
          onDownload: _cache[4] || (_cache[4] = ($event: any) => (downloadFile($event)))
        }, null, 8, ["modelValue", "files"]))
      : _createCommentVNode("", true),
    (activeInfoFile.value)
      ? (_openBlock(), _createBlock(_unref(InfoModal), {
          key: 3,
          modelValue: activeInfoFile.value,
          dimensions: activeInfoDimensions.value,
          duration: activeInfoDuration.value,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_unref(store).commit('files/setActiveInfoFile', null)))
        }, null, 8, ["modelValue", "dimensions", "duration"]))
      : _createCommentVNode("", true),
    (activeShareFile.value)
      ? (_openBlock(), _createBlock(_unref(ShareModal), {
          key: 4,
          modelValue: activeShareFile.value,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(store).commit('files/setActiveShareFile', null)))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _cache[21] || (_cache[21] = _createElementVNode("label", { for: "fileInputBtn" }, null, -1)),
    (_openBlock(), _createElementBlock("input", {
      id: "fileInputBtn",
      type: "file",
      class: "hidden bg-red-500 border text-white z-[1000]",
      ref_key: "fileInputBtn",
      ref: fileInputBtn,
      onChange: uploadFile,
      multiple: "",
      key: inputKey.value,
      onClick: _cache[7] || (_cache[7] = () => { if (fileInputBtn.value) fileInputBtn.value.value = '' })
    }, null, 32)),
    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "photoInputBtn" }, null, -1)),
    (_openBlock(), _createElementBlock("input", {
      id: "photoInputBtn",
      type: "file",
      accept: "image/*",
      class: "hidden",
      ref_key: "photoInputBtn",
      ref: photoInputBtn,
      onChange: uploadFile,
      multiple: "",
      key: `photo-${inputKey.value}`,
      onClick: _cache[8] || (_cache[8] = () => { if (photoInputBtn.value) photoInputBtn.value.value = '' })
    }, null, 32)),
    (!hideBar.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: toggleSidebar,
              class: _normalizeClass(["h-10 flex items-center transition-all duration-200", showSidebar.value ? 'justify-center' : 'justify-center'
          ])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: showSidebar.value
                ? '/icon/icon-close.svg'
                : '/icon/icon-open.svg',
                  alt: showSidebar.value ? 'close' : 'open',
                  class: "w-6 h-6 opacity-50 hover:opacity-100 transition"
                }, null, 8, _hoisted_6)
              ])
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["text-[var(--text)] font-semibold text-center", showSidebarMovil.value ? 'inline w-full -ml-6' : 'hidden'])
            }, " Menu ", 2),
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "search",
              class: "text-[#a3a3a3]"
            }, null, -1)),
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSearch, ["prevent"]),
              class: _normalizeClass([showSidebarMovil.value ? 'hidden' : 'inline', "relative w-full ml-2"])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((query).value = $event)),
                onInput: handleInput,
                type: "text",
                placeholder: "Search everything",
                class: "w-full pl-8 pr-4 py-1 bg-[var(--bg-secondary)] border border-[#0B77F3]/50 rounded-full font-light text-[var(--text)] text-xs hover:shadow-[0_0_2px_2px_rgba(10,119,243,0.5)] hover:border-[var(--hover-border)] focus:shadow-[0_0_3px_3px_rgba(10,119,243,0.5)] focus:outline-none transition-all duration-300"
              }, null, 544), [
                [_vModelText, query.value]
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("img", {
                src: "/icon/icon-search.svg",
                alt: "Search Icon",
                class: "absolute left-1 top-1/2 -translate-y-1/2 w-5 pointer-events-none"
              }, null, -1))
            ], 34)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (showSidebar.value && !isHome.value)
        ? (_openBlock(), _createBlock(_unref(Sidebar), { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      "data-scroll-container": "app-content",
      class: _normalizeClass(["overflow-y-auto transition-[padding] duration-300", 
        !isAuth.value || isHome.value
          ? 'pl-0'
          : _unref(store).state.sidebar
            ? 'sm:pl-64'
            : 'sm:pl-12'
      ])
    }, [
      _createElementVNode("main", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_view)
        ])
      ]),
      (!showSidebar.value)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_10, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "w-full h-px bg-line" }, null, -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("a", {
                  href: `${usersLink.value}`,
                  target: "_blank",
                  class: "mb-10 sm:mb-0"
                }, [
                  _createElementVNode("img", {
                    src: isLight.value
                ? '/img/logo-digi-light.svg'
                : '/img/logo-digi.svg',
                    alt: "Logo",
                    class: "h-6 opacity-30 group-hover:opacity-100 courser-pointer"
                  }, null, 8, _hoisted_14)
                ], 8, _hoisted_13),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Products", -1)),
                    _createElementVNode("ul", _hoisted_17, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: isAuth.value ? '/app' : '/',
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" Sky ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://fireweb.digiapps.com.co/",
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Fireweb ")
                      ], -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://care.digiapps.com.co/",
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Care ")
                      ], -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://utils.digiapps.com.co/",
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Utils ")
                      ], -1))
                    ])
                  ]),
                  _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"text-left\" data-v-299a0d36><h3 class=\"text-sm text-[var(--text)] font-regular mb-4\" data-v-299a0d36>Contact Us</h3><ul class=\"space-y-2 text-xs text-[var(--text)] font-light pl-1\" data-v-299a0d36><li data-v-299a0d36><a href=\"https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=support@digiapps.com.co\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-299a0d36> Help Center </a></li><li data-v-299a0d36><a href=\"https://discord.gg/n8NHa6sJbc\" target=\"_blank\" class=\"opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out\" data-v-299a0d36> Discord </a></li></ul></div>", 1)),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-sm text-[var(--text)] font-regular mb-4" }, "Legal", -1)),
                    _createElementVNode("ul", _hoisted_19, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: `${usersLink.value}/privacy-policy`,
                          target: "_blank",
                          class: "opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out"
                        }, " Privacy Policy ", 8, _hoisted_20)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, "© " + _toDisplayString(_unref(currentYear)) + " digi systems All rights reserved.", 1),
                _createElementVNode("button", {
                  onClick: toggleTheme,
                  class: "rounded-full"
                }, [
                  _createElementVNode("img", {
                    src: isLight.value
                ? '/icon/icon-light.svg'
                : '/icon/icon-dark.svg',
                    alt: "theme toggle",
                    class: "w-5 h-5 opacity-70 hover:opacity-100 transition"
                  }, null, 8, _hoisted_23)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})